import React from 'react';
import { useForm } from '../../hooks/useForm';
import { consent, email, minLength, required } from '../../utils/validation';
import { FormField } from '../ui/FormField';
import { ConsentCheckbox } from '../ui/ConsentCheckbox';
import { FormStatus } from '../ui/FormStatus';
import { Button } from '../ui/Button';
export const contactPathways = ['General inquiry', 'Employer — hiring talent', 'Candidate — career opportunities', 'Executive search — confidential'];
export function ContactForm({
  initialPathway = ''
}: {
  initialPathway?: string;
}) {
  const {
    values,
    errors,
    status,
    setField,
    handleSubmit,
    reset
  } = useForm({
    pathway: initialPathway,
    name: '',
    email: '',
    organisation: '',
    message: '',
    consent: false
  }, {
    pathway: required('Inquiry type'),
    name: required('Your name'),
    email: email(),
    message: minLength('Message', 10),
    consent
  });
  return <form noValidate onSubmit={handleSubmit} className="space-y-5" aria-label="Contact form" data-id="element-93" data-mp="2uz6ja6u4g9cw">
      <FormField name="pathway" label="What is your inquiry about?" type="select" required options={contactPathways} value={values.pathway} error={errors.pathway} onChange={v => setField('pathway', v)} data-id="element-94" data-mp="328d22c4cf2vw" />
      <div className="grid gap-5 sm:grid-cols-2" data-id="element-95" data-mp="3c6ssecvjq84c">
        <FormField name="name" label="Full name" required autoComplete="name" value={values.name} error={errors.name} onChange={v => setField('name', v)} data-id="element-96" data-mp="3c4y7gyk9yg09" />
        <FormField name="email" label="Email" type="email" required autoComplete="email" value={values.email} error={errors.email} onChange={v => setField('email', v)} data-id="element-97" data-mp="3l7qyd0pjoppk" />
      </div>
      <FormField name="organisation" label="Organisation" autoComplete="organization" value={values.organisation} onChange={v => setField('organisation', v)} data-id="element-98" data-mp="3ux0owc4qq0bk" />
      <FormField name="message" label="Message" type="textarea" rows={5} required value={values.message} error={errors.message} onChange={v => setField('message', v)} data-id="element-99" data-mp="3q6a7bh44xc0" />
      <ConsentCheckbox checked={values.consent} error={errors.consent} onChange={v => setField('consent', v)} data-id="element-100" data-mp="csfn27zut2sk" />
      <FormStatus status={status} onReset={reset} data-id="element-101" data-mp="29stmravvd5fo" />
      <Button type="submit" size="lg" variant="navy" arrow data-id="element-102" data-mp="24sxegzg52rub">
        Send message
      </Button>
    </form>;
}